import HelpIcon from "@mui/icons-material/Help";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import LightModeIcon from "@mui/icons-material/LightMode";
import AppBar from "@mui/material/AppBar";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import LibraryBooksOutlinedIcon from "@mui/icons-material/LibraryBooksOutlined";
import LogoutIcon from "@mui/icons-material/Logout";
import TimelineIcon from "@mui/icons-material/Timeline";
import { IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./header.css";
import useThemeStore from "@/store/themeStore";

import dexcom_logo from "../../assets/dexcom-logo.png";
import { auth } from "../../auth/firebase-config";
import PDFViewer from "../chatpage/pdf-viewer-iframe";
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from "../ui/sheet";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../ui/tooltip";
import SessionTimeoutHandler from "@/components/login/session-timeout-handler";

const UserMenu = ({
  handleCloseUserMenu,
  isMenuOpen,
  userInfo,
  userRoles,
}: any) => {
  const navigate = useNavigate();

  const user = {
    name: userInfo[0],

    email: userInfo[1],
    img: userInfo[2],
  };

  const handleManageKnowledgeBase = () => {
    navigate("/knowledgebase");
    handleCloseUserMenu();
  };

  const handleManageUser = () => {
    navigate("/usermanagement");
    handleCloseUserMenu();
  };

  const handleOpenMlflow = async () => {
    handleCloseUserMenu();
    const accessToken = localStorage.getItem("accessToken");
    if (!accessToken) {
      console.error("No access token");
      return;
    }
    const apiUrl = import.meta.env.VITE_API_URL;
    const backendBase = apiUrl?.replace(/\/alchemist\/api\/v1\/?$/, "") || "";
    try {
      const res = await fetch(`${apiUrl}/mlflow/session`, {
        method: "POST",
        headers: { Authorization: `Bearer ${accessToken}` },
        credentials: "include",
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err?.detail || err?.message || "Failed to open MLflow");
      }
      const data = await res.json().catch(() => ({}));
      const token = data?.token;
      const url = token
        ? `${backendBase}/mlflow?token=${encodeURIComponent(token)}`
        : `${backendBase}/mlflow`;
      window.open(url, "_blank", "noopener,noreferrer");
    } catch (e) {
      console.error("MLflow session error:", e);
      window.alert(e instanceof Error ? e.message : "Failed to open MLflow");
    }
  };

  const handlelogout = () => {
    auth.signOut();
    localStorage.removeItem("userInfo");
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user_data");
    handleCloseUserMenu();
    navigate("/login");
  };

  return (
    <Box sx={{ mr: "40px" }}>
      <Menu
        id="menu-appbar"
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={isMenuOpen}
        onClose={handleCloseUserMenu}
        PaperProps={{
          sx: {
            width: "255px",
            m: 7,
            ml: -2,
          },
        }}
      >
        <Box display="flex" flexDirection="column" alignItems="center" p={1.3}>
          <Avatar
            src={user.img}
            alt={user.name}
            sx={{ width: 55, height: 55, mb: 1 }}
          />
          <Typography variant="h6" sx={{ fontWeight: "bold" }}>
            {user.name}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {user.email}
          </Typography>
        </Box>
        <Divider />
        {userRoles?.includes("admin") && (
          <MenuItem sx={{ m: 1 }} onClick={handleManageKnowledgeBase}>
            <ListItemIcon>
              <LibraryBooksOutlinedIcon />
            </ListItemIcon>
            <Typography fontWeight="600" variant="inherit">
              Manage Knowledge Base
            </Typography>
          </MenuItem>
        )}
        {userRoles?.includes("admin") && (
          <MenuItem sx={{ m: 1 }} onClick={handleManageUser}>
            <ListItemIcon>
              <ManageAccountsIcon />
            </ListItemIcon>
            <Typography fontWeight="600" variant="inherit">
              User Management
            </Typography>
          </MenuItem>
        )}
        {userRoles?.includes("admin") && (
          <MenuItem sx={{ m: 1 }} onClick={handleOpenMlflow}>
            <ListItemIcon>
              <TimelineIcon />
            </ListItemIcon>
            <Typography fontWeight="600" variant="inherit">
              MLflow
            </Typography>
          </MenuItem>
        )}
        <Divider />
        <MenuItem
          sx={{ m: 1 }}
          onClick={() => {
            handlelogout();
          }}
        >
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <Typography fontWeight="600" variant="inherit">
            Logout
          </Typography>
        </MenuItem>
        <Divider />
      </Menu>
    </Box>
  );
};

export default function Header({
  gcsPath = "gs://dxcm_user_guide/DexcomPhase 2 __ User Guide For Generate New Document.pdf",
}) {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const handleOpenUserMenu = () => setIsMenuOpen(true);
  const handleCloseUserMenu = () => setIsMenuOpen(false);

  const { isDarkMode, toggleDarkMode } = useThemeStore();

  const [userInfo, setUserInfo] = useState(null);
  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [profileimg, setprofileimg] = useState("");
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    const storedUserInfo = localStorage.getItem("userInfo");
    if (storedUserInfo) {
      const uinfo = JSON.parse(storedUserInfo);
      setname(uinfo.name);
      setemail(uinfo.email);
      setprofileimg(uinfo.profileImage);

      setUserInfo(JSON.parse(storedUserInfo));
    }
    const userData = localStorage.getItem("user_data");
    if (userData) {
      const parsedUserData = JSON.parse(userData);
      setRoles(parsedUserData.roles);
    }
  }, []);

  return (
    <>
      <SessionTimeoutHandler />
      <Box>
        <AppBar position="static" color="transparent" className="app-bar">
          <Toolbar sx={{ minHeight: "64px !important", padding: "0 24px" }}>
            <img
              src={dexcom_logo}
              alt="logo"
              className="logo"
              onClick={() => navigate("/dashboard")}
              style={{ cursor: "pointer" }}
            />
            <Box className="flex-grow" />
            {/* Dark Mode Toggle */}
            <TooltipProvider>
              <Tooltip>
                <TooltipTrigger asChild>
                  <IconButton
                    onClick={toggleDarkMode}
                    sx={{
                      margin: "0 8px",
                      color: isDarkMode ? "#0db02b" : "#666",
                      "&:hover": {
                        backgroundColor: isDarkMode ? "rgba(13, 176, 43, 0.1)" : "rgba(0, 0, 0, 0.05)",
                      },
                    }}
                  >
                    {isDarkMode ? <LightModeIcon /> : <DarkModeIcon />}
                  </IconButton>
                </TooltipTrigger>
                <TooltipContent className="bg-black">
                  <p className="text-white">
                    {isDarkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
                  </p>
                </TooltipContent>
              </Tooltip>
            </TooltipProvider>
            <IconButton 
              sx={{ 
                margin: "0 8px",
                color: isDarkMode ? "#0db02b" : "#666",
                "&:hover": {
                  backgroundColor: isDarkMode ? "rgba(13, 176, 43, 0.1)" : "rgba(0, 0, 0, 0.05)",
                },
              }}
            >
              <TooltipProvider>
                <Tooltip>
                  <TooltipTrigger>
                    <Sheet>
                      <SheetTrigger>
                        <HelpIcon />
                      </SheetTrigger>
                      <SheetContent style={{ maxWidth: "50vw" }}>
                        <SheetHeader>
                          <SheetTitle>User Guide</SheetTitle>
                          <SheetDescription>
                            <div className="font-semibold"></div>
                            <PDFViewer gcsPath={gcsPath} />
                          </SheetDescription>
                        </SheetHeader>
                      </SheetContent>
                    </Sheet>
                  </TooltipTrigger>
                  <TooltipContent className="bg-black">
                    <p className="text-white">View User Guide</p>
                  </TooltipContent>
                </Tooltip>
              </TooltipProvider>
            </IconButton>
            {/* Profile Section */}
            <Box className="profile-section">
              <Divider
                orientation="vertical"
                sx={{ 
                  height: "32px",
                  borderColor: isDarkMode ? "rgba(13, 176, 43, 0.3)" : "rgba(0, 0, 0, 0.12)",
                }}
                variant="middle"
                flexItem
              />

              {/* Profile Image and Name */}
              <Box
                onClick={handleOpenUserMenu}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  gap: "8px",
                  padding: "4px 8px",
                  borderRadius: "8px",
                  "&:hover": {
                    backgroundColor: isDarkMode ? "rgba(13, 176, 43, 0.1)" : "rgba(0, 0, 0, 0.05)",
                  },
                }}
              >
                <Avatar
                  src={profileimg}
                  alt={name}
                  sx={{
                    width: "36px",
                    height: "36px",
                    cursor: "pointer",
                    border: isDarkMode ? "2px solid #0db02b" : "2px solid #137d00",
                  }}
                />

                <Typography
                  variant="body1"
                  component="div"
                  sx={{ 
                    fontWeight: 600,
                    fontSize: "15px",
                    color: isDarkMode ? "#ffffff" : "#000000",
                  }}
                >
                  {name}
                </Typography>
              </Box>
            </Box>
          </Toolbar>
        </AppBar>
      </Box>
      <UserMenu
        handleCloseUserMenu={handleCloseUserMenu}
        isMenuOpen={isMenuOpen}
        userInfo={[name, email, profileimg]}
        userRoles={roles}
      />
    </>
  );
}
